/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosRequestConfig } from 'axios';

import { env } from 'config/env';
import { store } from 'config/storage';

import { authLoaders } from 'entities/modules/auth/loaders';
import { authMutations } from 'entities/modules/auth/mutations';

import { navigateToLogin, shouldRefreshSession } from 'providers/Auth/utils';
import { extractApiError } from './errors';

export const api = axios.create({
  baseURL: env.apiUrl,

  headers: {
    'X-Client-Id': env.apiClientId,
  },
});

async function refreshToken(token: string) {
  const tokens = await authLoaders.refreshSession.load({ refreshToken: token });

  return tokens;
}

async function addAuthTokenToRequest(config: AxiosRequestConfig): Promise<AxiosRequestConfig> {
  const user = store.user.get();

  if (!user) throw new Error('Unauthenticated call');

  let token = user.accessToken;

  if (shouldRefreshSession(user)) {
    const tokens = await refreshToken(user.refreshToken);

    store.user.set({ ...user, ...tokens });

    token = tokens.accessToken;
  }

  const updatedConfig = {
    ...config,
    headers: {
      ...config.headers,
      authorization: `Bearer ${token}`,
    },
  };

  return updatedConfig;
}

export const unauthedApi = axios.create({
  baseURL: env.apiUrl,

  headers: {
    'X-Client-Id': env.apiClientId,
  },
});

api.interceptors.request.use(addAuthTokenToRequest as any);

api.interceptors.response.use(null, async (err) => {
  const { code } = extractApiError(err);

  if (code === 'FORCE_LOGOUT') {
    await authMutations.purgeSession.action();

    store.user.delete();

    navigateToLogin();
  }

  return Promise.reject(err);
});
